import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import moment from 'moment';
import { Select } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { fetchSessions } from 'slices/sessionSlice';
import BasicTabs from 'components/common/Tabs';
import { Box } from '@mui/material';
import { CustomTabPanel } from 'components/common/Tabs';
import { fetchLocations } from 'slices/locationSlice';
import { fetchLanguages } from 'slices/languageSlice';
import SessionViewList from './SessionViewList';
import { setAddAppointmentPopup } from 'slices/appointmentSlice';
import { AddSessionModal } from 'components/SessionForm';
import { appointmentsSelector } from 'slices/appointmentSlice';
import { closeAppointmentPopup } from 'slices/appointmentSlice';
import { sessionsSelector } from 'slices/sessionSlice';
import { PAGELENGTH } from 'components/common/ListLayout';

const tabItems = [
    { label: "Active Sessions", value: 0, },
    { label: "Upcoming Session", value: 1, },
    { label: "Past Sessions", value: 2, },

]

const TypeOptions = [
    { label: "Audio", value: "Audio" },
    { label: "Video", value: "Video" },
];

const sessionTypeOptions = [
    { label: "On Demand", value: "On Demand" },
    { label: "Scheduled", value: "Scheduled" },
];

const Sessions = () => {
    const dispatch = useDispatch();
    const startDateRef = React.useRef(null);
    const [tabIndex, setTabIndex] = React.useState(0);
    const [locationState, setLocationState] = useState(null);
    const [languageState, setLanguageState] = useState(null)
    const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);
    const {sessions, current_page, per_page } = useSelector(sessionsSelector);
    const [sessionStaus, setSessionStaus] = useState('active')

    const defaultValues = {
        hospitals: "",
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        patient_langauges: "",
        session_type: ""

    };

    const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, reset, getValues } = useForm({
        defaultValues: defaultValues
    });

    useEffect(() => {
        setValue("patient_langauges", "");
    }, []);

    const filteredLocationLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchLocations(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map((item) => ({
                value: item.id,
                label: item?.user?.name,
            })),
            hasMore: page !== result?.last_page,
            additional: { page: page + 1 },
        };
    };

    const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(language => ({
                value: language.id,
                label: language.name,
            })),
            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };

    const handleResetFields = () => {
        reset(defaultValues);
        dispatch(fetchSessions({...defaultValues, page: current_page || 1 }, sessionStaus));
    };

    const onSubmit = (data) => {
        dispatch(fetchSessions({...data,  pageLength: per_page || PAGELENGTH}, sessionStaus));
    };



    // session create 
    const callback = () => {
        handleClose();
        appointmentPopUpState?.callback && appointmentPopUpState?.callback();
    };

    const handleClose = () => {
        dispatch(closeAppointmentPopup());
        handleResetFields()
    };
    const handleAddAppointmentPopUp = (item) => {
        dispatch(
            setAddAppointmentPopup({
                show: true,
                item,
            })
        );
    };


    return (
        <div className="content" style={{}}>
            <div className="card_table">
                <form className="invoicing_form">
                    <div className='d-flex gap-3'>
                        <Box sx={{ width: '100%', marginBottom: 2 }}>
                            <BasicTabs
                                setValue={(index)=>{
                                    setSessionStaus(index == 0 ? "active" : index === 1 ? "upcoming" : 'past')
                                    setTabIndex(index)
                                }} value={tabIndex}
                                tabItems={tabItems}
                            />
                        </Box>

                        {/* <button type='button' className='main_button' onClick={() => handleAddAppointmentPopUp()}>Add Session</button> */}
                    </div>

                    <div className='filter_wrapper'>
                        <div className='row_filters'>
                            <img src="/images/filter.png" alt="" />
                            <h3>Filters</h3>
                        </div>

                        <div className='theme_form_2'>

                            <div className="row-primary row_secondary">
                                <h2>Start Date</h2>
                                <Controller
                                    name="start_date"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="input-image">
                                            <input ref={startDateRef} id='date' type="date" name='start_date' placeholder='Select Start Date' required
                                                {...field}
                                                value={field.value}
                                                onChange={(e) => field.onChange(moment(new Date(e.target.value)).format("YYYY-MM-DD"))}
                                            />
                                            <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                        </div>
                                    )} />
                            </div>
                            <div className="row-primary row_secondary">
                                <h2>End Date</h2>
                                <Controller
                                    name="end_date"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="input-image">
                                            <input ref={startDateRef} id='date' type="date" name='end_date' placeholder='Select End Date' required
                                                {...field}
                                                value={field.value}
                                                onChange={(e) => field.onChange(moment(new Date(e.target.value)).format("YYYY-MM-DD"))}
                                            />
                                            <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                        </div>
                                    )} />
                            </div>
                            <div className="row-primary row_secondary">
                                <h2>Location</h2>
                                <Controller
                                    name="location_id"
                                    control={control}
                                    render={({ field }) => (
                                        <div style={{ width: "100%" }}>
                                            <AsyncPaginate
                                                menuPlacement='auto'
                                                styles={{
                                                    ...selectCustomStyles,
                                                }}
                                                value={locationState || null}
                                                loadOptions={filteredLocationLoadOptions}
                                                isClearable
                                                escapeClearsValue
                                                onChange={(obj) => {
                                                    if(obj){
                                                        setLocationState(obj);
                                                        field.onChange(obj?.value)
                                                    }
                                                    else{
                                                        setLocationState(null);
                                                        field.onChange("")

                                                    }
                                                }}
                                                additional={{
                                                    page: 1,
                                                }}
                                            />
                                            {errors?.location_ids?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.location_ids?.message} />
                                                </div>
                                            }
                                        </div>
                                    )}
                                />
                            </div>
                            <div className="row-primary row_secondary">
                                <h2>Language</h2>
                                <Controller
                                    name={`language_ids`}
                                    control={control}
                                    render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <AsyncPaginate
                                                menuPlacement='auto'
                                                styles={{
                                                    ...selectCustomStyles,
                                                }}
                                                value={languageState || null}
                                                loadOptions={filteredLanguagesLoadOptions}
                                                isClearable
                                                escapeClearsValue
                                                onChange={(obj) => {
                                                    if(obj){
                                                        setLanguageState(obj);
                                                        field.onChange(obj?.value)
                                                    }
                                                    else{
                                                        setLanguageState(null);
                                                        field.onChange("")

                                                    }
                                                }}
                                                additional={{
                                                    page: 1,
                                                }}
                                            />
                                            {
                                                errors?.language_ids?.length && errors?.language_ids?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.language_ids?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>
                            <div className="row-primary row_secondary">
                                <h2>Call Type</h2>
                                <Controller
                                    name="call_type"
                                    control={control}
                                    render={({ field }) => (
                                        <div className='select_box' style={{ width: "100%" }}>
                                            <Select
                                                name="call_type"
                                                options={TypeOptions}
                                                value={TypeOptions.find(opt => opt.value === field.value) || ""}
                                                onChange={(value) => {
                                                    field.onChange(value);
                                                }}
                                                
                                            />
                                        </div>
                                    )}
                                />
                            </div>
                            <div className="row-primary row_secondary">
                                <h2>Session Type</h2>
                                <Controller
                                    name="session_type"
                                    control={control}
                                    render={({ field }) => (
                                        <div className='select_box' style={{ width: "100%" }}>
                                            <Select
                                                name="session_type"
                                                options={sessionTypeOptions}
                                                value={sessionTypeOptions.find(opt => opt.value === field.value) || ""}
                                                onChange={(value) => {
                                                    field.onChange(value);
                                                }}
                                                
                                            />
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="row-primary row_secondary">
                                <h2 className='invisible'>hidden</h2>
                                <div className='d-flex gap-2' style={{ width: 'fit-content' }}>
                                    <SubmitButton handleSubmit={handleSubmit(onSubmit)} btnText="Search" className={'green'} />
                                    <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reset" handleSubmit={handleResetFields} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <CustomTabPanel value={tabIndex} index={0}>
                    <SessionViewList sessionStaus={'active'} />
                </CustomTabPanel>
                <CustomTabPanel value={tabIndex} index={1}>
                    <SessionViewList sessionStaus={'upcoming'} />
                </CustomTabPanel>
                <CustomTabPanel value={tabIndex} index={2}>
                    <SessionViewList sessionStaus={'past'} />
                </CustomTabPanel>

                {/* <AddSessionModal
                    show={appointmentPopUpState.show}
                    item={appointmentPopUpState.item}
                    onClose={handleClose}
                    afterUpdated={callback}

                /> */}
            </div>
        </div>
    );
}

export default Sessions